import React, { useState } from 'react'

import { CoachReferralView } from 'partials/CoachRreferralView'
import { Page } from 'partials/Page'
import { TermsModal } from 'partials/TermsModal'

import { Box } from 'widgets/Box'
import { Button } from 'widgets/Button'
import { Checkbox } from 'widgets/Checkbox'
import { Icon } from 'widgets/Icon'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { useCoachReferral } from 'hooks/useCoachReferral'
import { useMaxWidth } from 'hooks/useMaxWidth'

import { links } from 'utils/constants'

export const UserTypeSelectPage = ({ navigation }: any) => {
  const coachReferral = useCoachReferral()
  const maxWidth = useMaxWidth()

  const [isAgreementModalOpen, setIsopenAgreementModalOpen] = useState(false)

  const [acceptedTerms, setAcceptedTerms] = useState(false)

  const openAgreementPostModal = () => {
    setIsopenAgreementModalOpen(true)
  }

  const closeAgreementPostModal = () => {
    setIsopenAgreementModalOpen(false)
  }

  const AcceptAgreement = () => {
    setAcceptedTerms(true)
    setIsopenAgreementModalOpen(false)
  }

  const handleSubmit = () => {
    navigation.navigate(links.ONBOARDING_EDIT_PROFILE_PAGE)
  }

  const handleIAccept = () => {
    setAcceptedTerms(!acceptedTerms)
  }

  return (
    <Page withScroll navigation={navigation} backgroundColor='black'>
      <Box flex={1} display='flex' flexDirection='column'>
        {coachReferral.isReferral && (
          <>
            <Box margin='xl' />
            <CoachReferralView data={coachReferral} />
          </>
        )}

        {!coachReferral.isReferral && (
          <Box
            testID='UpswingLogoContainer'
            height={maxWidth.width * 0.8}
            flexDirection='column'
            align='center'
            justifyContent='center'
          >
            <Box>
              <Box height={64} />
              <Icon color='white' name='upspace-logo-mark' size={150} />
            </Box>
            <Box margin='sm'>
              <Icon color='white' name='upspace-word-mark' size={42} />
            </Box>
          </Box>
        )}

        <Box testID='ContentContainer' flex={1} flexDirection='column'>
          <Box justifyContent='center' align='center' margin={{ vertical: 'xl', horizontal: 'md' }}>
            <Box>
              <Button
                title='View user agreement'
                type='grey'
                padding={{ vertical: 'sm', horizontal: 'lg' }}
                onPress={() => openAgreementPostModal()}
              />
            </Box>
            <Box>
              <Checkbox title='I accept' selected={acceptedTerms} onPress={handleIAccept} />
            </Box>
          </Box>

          <Box margin={{ horizontal: 'md', vertical: 'md' }}>
            <Pressable disabled={!acceptedTerms} onPress={handleSubmit}>
              <Box
                height={50}
                align='center'
                borderRadius='xs'
                justifyContent='center'
                backgroundColor='v2primary'
                style={!acceptedTerms && { opacity: 0.5 }}
              >
                <Text bold>LET&apos;S GO!</Text>
              </Box>
            </Pressable>
          </Box>
          <Box height={44} />
        </Box>

        <TermsModal
          handleClose={closeAgreementPostModal}
          isOpen={isAgreementModalOpen}
          acceptAgreement={AcceptAgreement}
          testID='TermsModal'
        />
      </Box>
    </Page>
  )
}
